import { render, staticRenderFns } from "./notification-config.vue?vue&type=template&id=c4552542"
import script from "./notification-config.vue?vue&type=script&lang=js"
export * from "./notification-config.vue?vue&type=script&lang=js"
import style0 from "./notification-config.vue?vue&type=style&index=0&id=c4552542&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports